import boardNotFound from '@atlassian/jira-boards-common/src/flags/board-not-found/index.tsx';
import {
	type Action,
	DELETED,
	DELETE_FAILED,
	COPIED,
	COPY_FAILED,
	MOVED,
	MOVE_FAILED,
} from '../state/actions/operations/index.tsx';
import {
	getRapidBoardUrlForCopiedBoard,
	getRapidBoardEditUrlForCopiedBoard,
} from '../state/selectors/boards/index.tsx';
import type { State } from '../state/types.tsx';
import copyFailed from './copy/failed/index.tsx';
import copied from './copy/success/index.tsx';
import deleteFailed from './delete/failed/index.tsx';
import deleted from './delete/success/index.tsx';
import moveFailed from './move/failed/index.tsx';
import moved from './move/success/index.tsx';

const BOARD_NOT_FOUND_REASON = 'board-not-found';

const flagsMapper = (action: Action, state: State) => {
	switch (action.type) {
		case DELETED: {
			return deleted(action.payload.board);
		}
		case DELETE_FAILED: {
			if (action.payload.reason === BOARD_NOT_FOUND_REASON) {
				return boardNotFound(action.payload.board);
			}

			return deleteFailed(action.payload.board);
		}
		case COPIED: {
			const { board, copiedBoardSummary } = action.payload;
			return copied(
				board,
				copiedBoardSummary,
				getRapidBoardUrlForCopiedBoard(state, copiedBoardSummary.id, copiedBoardSummary.location),
				getRapidBoardEditUrlForCopiedBoard(
					state,
					copiedBoardSummary.id,
					copiedBoardSummary.location,
				),
			);
		}
		case COPY_FAILED: {
			if (action.payload.reason === BOARD_NOT_FOUND_REASON) {
				return boardNotFound(action.payload.board);
			}

			return copyFailed(action.payload.board);
		}
		case MOVED: {
			return moved(action.payload.board);
		}
		case MOVE_FAILED: {
			return moveFailed(action.payload.board);
		}
		default: {
			const _exhaustiveCheck: never = action;
			return undefined;
		}
	}
};

export default flagsMapper;
